import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import { DataTable } from "components/ui/DataTable";
import { pathGenerators } from "utils/routes";

import { formatCurrency } from "../constants";

const PaymentsDueTab = ({
  data,
  isLoading,
  totalCount,
  currentPage,
  onPageChange,
  rowsPerPage,
  onRowsChange,
}) => {
  const formatDate = (date) => {
    if (!date) return "-";

    return moment(date).format("YYYY-MM-DD");
  };

  const columns = useMemo(
    () => [
      {
        id: "latestDueDate",
        header: "Latest Due",
        width: "minmax(120px, 1fr)",
        render: (row) => formatDate(row.latestDueDate),
      },
      {
        id: "patientName",
        header: "Patient Name",
        width: "minmax(200px, 1fr)",
        render: (row) => (
          <Link
            to={pathGenerators.patient.payments(row.patientId)}
            style={{
              color: "var(--green-700)",
              textDecoration: "none",
              fontWeight: 700,
              display: "flex",
              alignItems: "center",
              gap: "8px",
              overflow: "hidden",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.textDecoration = "underline")}
            onMouseLeave={(e) => (e.currentTarget.style.textDecoration = "none")}
          >
            <span
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                minWidth: 0,
              }}
            >
              {row.patientName || "-"}
            </span>
          </Link>
        ),
      },
      {
        id: "servicesOwed",
        header: "Services Owed",
        width: "minmax(120px, 1fr)",
        render: (row) => row.servicesOwed ?? 0,
      },
      {
        id: "oldestDueDate",
        header: "Oldest Due",
        width: "minmax(120px, 1fr)",
        render: (row) => formatDate(row.oldestDueDate),
      },
      {
        id: "totalAmountOwed",
        header: "Amount Owed",
        width: "minmax(120px, 1fr)",
        render: (row) => (
          <strong style={{ color: "#b70000" }}>
            {formatCurrency(row.totalAmountOwed)}
          </strong>
        ),
      },
    ],
    []
  );

  return (
    <DataTable
      columns={columns}
      data={data}
      getRowId={(row) => row.patientId}
      isLoading={isLoading}
      emptyTitle="No payments due"
      emptyText="There are no outstanding patient payments at this time."
      totalCount={totalCount}
      currentPage={currentPage}
      onPageChange={onPageChange}
      rowsValue={rowsPerPage}
      onRowsChange={(value) => {
        onRowsChange(value);
        onPageChange(1);
      }}
      noScroll
    />
  );
};

export { PaymentsDueTab };
